export default "__VITE_ASSET__06617164__"